(function () {
	'use strict';

	var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

	$('[data-filter]').each(function () {
		var filter = $(this);
		var targets = $(filter.attr('data-filter'));

		filter.find('a[href="#all"]').addClass('selected');

		filter.on('click', 'a', function (e) {
			e.preventDefault();

			var clicked = $(this);
			var clickedFilter = clicked.attr('href').substr(1);

			filter.find('a').removeClass('selected');
			clicked.addClass('selected');
			targets.removeClass('hide');

			if (clickedFilter != 'all') {
				targets.filter(function () {
					return $(this).attr('data-filters').indexOf(clickedFilter) === -1;
				}).addClass('hide');
			}
		});
	});
})();
